import React, { useState, useEffect } from 'react';
import { handleError, handleErrorToast } from '../shared/Functions';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import ImageIcon from '@material-ui/icons/Image';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { authProvider } from '../../services/Security';
import { RouteList } from './RouteList';
import { useHistory } from 'react-router';
import { RoutesVService } from '../../services/V2/aurascope';
import { DistrictsVService } from '../../services/V2/padre';
import { CustomTable } from '../shared/CustomTable';

export const MeterRoutes = (props) => {
    const history = useHistory();

    const [token, setToken] = useState<any>();
    const [districtId, setDistrictId] = useState<any>();
    const [district, setDistrict] = useState<any>();
    const [routeId, setRouteId] = useState<string>();
    const [loading, setLoading] = useState<boolean>(true);
    const [canUpdateRoutes, setCanUpdateRoutes] = useState<boolean>(false);
    const [canCreateRoutes, setCanCreateRoutes] = useState<boolean>(false);
    const [canReadImages, setCanReadImages] = useState<boolean>(false);
    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [showEdit, setShowEdit] = useState<boolean>(false);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setDistrictId(data?.districtId)
        setToken(data?.token)
        setLoading(!loading)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        if (!token || !districtId) return;
        DistrictsVService.districtsVGetById(districtId ?? "")
            .then(x => setDistrict(x))
            .catch(x => handleError(x))

        let perms = authProvider.getPermissions();
        setCanUpdateRoutes(perms.some((perm: string) => perm === "UpdateRoutes"));
        setCanCreateRoutes(perms.some((perm: string) => perm === "CreateRoutes"));
        setCanReadImages(perms.some((perm: string) => perm === "ReadMeterReaderImages"));
    }, [token, districtId])// eslint-disable-line react-hooks/exhaustive-deps

    const handleShowEdit = row => {
        setRouteId(row.id)
        setShowEdit(true)
    }

    const copyRoute = row => {
        let copyRoute = {
            ...row,
            name: `Clone of ${row.name}`
        }

        RoutesVService.routesVCreate(copyRoute)
            .then(x => {
                setLoading(!loading)
                props.successToast(`Created as "Clone of ${row.name}"`);
                handleShowEdit(x);
            })
            .catch(err => props.errorToast(handleErrorToast(err)))
    }

    return (
        <React.Fragment>
            {showAdd &&
                <RouteList
                    districtId={district.id}
                    operatorId={district.operatorId}
                    routeId={null}
                    setShow={setShowAdd}
                    loading={loading}
                    setLoading={setLoading}
                    endpoint={RoutesVService.routesVCreate}
                    defaultDisabled={false}
                    failCallback={props.errorToast}
                    isAdd={true} />
            }
            {showEdit &&
                <RouteList
                    districtId={district.id}
                    operatorId={district.operatorId}
                    routeId={routeId}
                    setShow={setShowEdit}
                    loading={loading}
                    setLoading={setLoading}
                    endpoint={RoutesVService.routesVUpdate}
                    defaultDisabled={true}
                    failCallback={props.errorToast}
                    isAdd={false} />
            }
            <CustomTable
                title="Meter Routes"
                columns={[
                    { title: 'Id', field: 'id', editable: 'never' },
                    { title: 'Name', field: 'name', editable: 'never' },
                    { title: 'UserName', field: 'userName', editable: 'never', sorting: false },
                    { title: 'User Id', field: 'userId', editable: 'never' },
                    { title: 'Active?', field: 'isActive', type: 'boolean', editable: 'never' }
                ]}
                dataEndpoint={query => {
                    return new Promise((resolve, reject) => {
                        if (!districtId) resolve({
                            data: [],
                            page: query.page,
                            totalCount: 0
                        })
                        else
                            RoutesVService.routesVGetAll({
                                pageNumber: query.page + 1,
                                numberPerPage: query.pageSize,
                                orderBy: query?.orderBy?.field?.toString() ?? "Name",
                                orderByDesc: query.orderDirection === "desc",
                                filters: [{
                                    property: "DistrictId",
                                    value: districtId
                                }],
                                searchQuery: query.search
                            }).then((x: any) => {
                                resolve({
                                    data: x.items ?? [],
                                    page: query.page,
                                    totalCount: x.numberOfItems ?? 0
                                })
                            }).catch(x => {
                                reject(x)
                            })
                    })
                }}
                actions={[
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => { setLoading(!loading) },
                    },
                    {
                        icon: () => <AddIcon />,
                        tooltip: 'Add Route',
                        isFreeAction: true,
                        onClick: () => setShowAdd(!showAdd),
                        disabled: !canCreateRoutes
                    },
                    {
                        icon: () => <EditIcon />,
                        tooltip: 'View/Edit Route',
                        onClick: (event, row) => handleShowEdit(row),
                        disabled: !canUpdateRoutes
                    },
                    {
                        icon: () => <ImageIcon />,
                        tooltip: 'View Images',
                        onClick: (e, r: any) => history.replace(`/app/meter-routes/${r.id}/meter-images`),
                        disabled: !canReadImages
                    },
                    {
                        icon: () => <FileCopyIcon />,
                        tooltip: 'Copy Route',
                        onClick: (e, r) => copyRoute(r),
                        disabled: !canCreateRoutes
                    }
                ]}
                refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataSet={null}
            />
        </React.Fragment>
    );
}